import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import expressConfig from "src/config/express.json";
import CheckoutForm from "./CheckoutForm";

const env = process.env.NODE_ENV || "development";
const stripePublishableKey = expressConfig[env].STRIPE_PUB_KEY;
const stripePromise = loadStripe(stripePublishableKey);

interface ISubscriptionData {
  maxAgents: number;
  new_plan: string;
  priceId: string;
}

interface IBillingForm {
  formRef: any;
  clientSecret: string;
  setLoader: (a: boolean) => void;
  closeModal: () => void;
  subscriptionData: ISubscriptionData;
}

const BillingForm: React.FC<IBillingForm> = ({
  formRef,
  clientSecret,
  setLoader,
  closeModal,
  subscriptionData,
}) => {
  if (!clientSecret || !stripePromise) return null;

  return (
    <Elements stripe={stripePromise} options={{ clientSecret }}>
      <CheckoutForm
        formRef={formRef}
        setLoader={setLoader}
        closeModal={closeModal}
        subscriptionData={subscriptionData}
      />
    </Elements>
  );
};

export default BillingForm;
